import * as searchTypes from '../types/searchTypes'

const INITIAL_STATE = {
  search: ""
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case searchTypes.APPLY_SEARCH:
      return { ...state, search: action.payload };
    default:
      return state;
  }
};